import directive from './directive'

export default {
  name: 'num-mask',
  directive
}
